import { render, staticRenderFns } from "./main-notice-list.vue?vue&type=template&id=1219933f&scoped=true&"
import script from "./main-notice-list.vue?vue&type=script&lang=js&"
export * from "./main-notice-list.vue?vue&type=script&lang=js&"
import style0 from "./main-notice-list.vue?vue&type=style&index=0&id=1219933f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1219933f",
  null
  
)

export default component.exports